export const namespace = 'common';
